import { render, staticRenderFns } from "./Denounce-notification-pagination.vue?vue&type=template&id=824b9a18"
import script from "./Denounce-notification-pagination.vue?vue&type=script&lang=js"
export * from "./Denounce-notification-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports